<template lang="">
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-4 mb-4">
        <v-col cols="12" md="8">
          <BaseHelp />
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import BaseHelp from '../organisms/BaseHelp.vue';

export default {
  name: 'HelpPage',
  components: {
    BaseHelp,
  },
}
</script>
<style lang="">
</style>